import { toast } from "@loot-os/ui/components/sonner";
import { Switch } from "@loot-os/ui/components/switch";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useTRPC } from "../lib/trpc";
import { useTenantRole } from "../lib/useTenantRole";

/**
 * The user's auto-claim switch, the same preference the shopper flips on the storefront. On,
 * each box reveal and battle result is claimed for them the moment it lands. Editors and admins
 * only; a viewer reads the state from the card's text.
 */
export function AutoClaimControl({
  endUserId,
  autoClaim,
}: {
  endUserId: string;
  autoClaim: boolean;
}) {
  const { can } = useTenantRole();
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const set = useMutation(
    trpc.users.setAutoClaim.mutationOptions({
      onSuccess: (result) => {
        toast.success(result.autoClaim ? "Auto-claim turned on." : "Auto-claim turned off.");
        void queryClient.invalidateQueries({ queryKey: trpc.users.pathKey() });
      },
    }),
  );
  if (!can("editor")) return null;

  return (
    <Switch
      aria-label="Auto-claim reveals and battle results"
      checked={autoClaim}
      disabled={set.isPending}
      onCheckedChange={(checked) => set.mutate({ endUserId, autoClaim: checked })}
    />
  );
}
